<template>
  <div>
    <p class="cm-mg-p-wzd text-left text-muted">
      2.1 {{ $t('labor.abscence_type_info') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-12 col-md-4 col-lg-3">
        <div class="row">
          <div class="col-12">
            <fg-input
              :label="`${$t('common_words.maximum')}: *`"
              type="number"
              v-model="model.maximum"
              name="common_words.maximum"
              v-validate="modelValidations.maximum"
              :error="getError('common_words.maximum', true)"
              :placeholder="`${$t('labor.maximum_time_abscence')}...`"
            ></fg-input>
          </div>
          <div class="col-12">
            <fg-input
              :label="`${$t('common_words.minimum')}: *`"
              type="number"
              v-model="model.minimum"
              name="common_words.minimum"
              v-validate="modelValidations.minimum"
              :error="getError('common_words.minimum', true)"
              :placeholder="`${$t('labor.minimum_time_abscence')}...`"
            ></fg-input>
          </div>
          <div class="col-12">
            <div class="form-group has-label">
              <label>{{ $t('common_words.approval') }}?: *</label>
              <el-select
                filterable
                class="select-primary mb-3 shadow-sm required-approval"
                v-model="model.approval"
                :placeholder="`${$t('common_words.select2')}...`"
              >
                <el-option
                  class="select-primary"
                  v-for="item in [
                    { id: 0, value: $t('common_words.no') },
                    { id: 1, value: $t('common_words.yes') },
                  ]"
                  :key="item.id + item.value"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-8 col-lg-9">
        <div class="form-group has-label">
          <div class="form-group has-label">
            <label>{{ $t('common_words.description') }}: *</label>
            <br />
            <el-input
              maxlength="150"
              show-word-limit
              class="shadow-sm"
              type="textarea"
              :rows="10"
              :placeholder="`${$t('labor.enter_abscence_type')}...`"
              v-model="model.description"
            ></el-input>
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';

export default {
  data() {
    return {
      model: {
        approval: null,
        minimum: null,
        maximum: null,
        description: null,
      },
      modelValidations: {
        maximum: {
          required: true,
          numeric: true,
        },
        minimum: {
          required: true,
          numeric: true,
        },
      },
    };
  },
  mixins: [MixinPermissions, MixinForm, mixinMasters],
  methods: {
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', this.model);

          return res;
        })
        .then((resp) => {
          if (!resp) return resp;
          else if (
            Number(this.model.approval) !== null &&
            ![0, 1].includes(Number(this.model.approval))
          ) {
            return this.validationInputsRequired('approval');
          } else {
            return true;
          }
        });
    },
  },

  created() {},

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model = { ...editForm };
    }
  },
};
</script>
<style></style>
